import { preferAdjustmentConciliationRows } from './conciliationRows'

export const isPreviousYearConciliationLinkage = item => {
  const description = String(item?.descripcion ?? '').trim()
  return (
    [22, 23].includes(Number(item?.libroContableOriginTableId)) ||
    /^(cobro|pago)\s+f\//i.test(description)
  )
}

// Identidad de UI: no reemplaza el idPrincipal que se envía al desconciliar.
export const getPreviousYearConciliationRowKey = item => {
  if (!item || !(isPreviousYearConciliationLinkage(item) || item._origen === 'gestion' || item.tipo === 'gestion')) {
    return undefined
  }
  if (item.idcuota != null) return `gestion-cuota-${item.idcuota}`
  const id = [item.idPrincipal, item.realId, item.id]
    .find(value => value != null && String(value).trim() !== '' && Number(value) !== 0)
  return String(id ?? item.customId ?? 'custom-gestion-principal')
}

export const normalizeConciliationLinkageItem = item => {
  if (!item || typeof item !== 'object') return item

  const amount = Number(item.monto ?? item.montoTotal ?? item.montoCargo ?? item.montoAbono ?? 0)
  const movementTable = [item.tabla, item.tablaPrincipal]
    .map(Number)
    .find(value => value === 6 || value === 7)
  const tipoMovimiento =
    item.tipoMovimiento ??
    (movementTable === 7 ? 'cargo' : movementTable === 6 ? 'abono' : undefined)
  const displayName = item.name ?? item.nombreFolio ?? item.nombreBanco ?? item.razonSocial
  const displayNumber =
    item.numero ?? item.numeroFolio ?? item.numeroBanco ?? item.numeroCuentaBanco ?? item.rut
  // `origen` puede describir el documento padre (por ejemplo, una boleta SII),
  // mientras tabla/tablaPrincipal identifica el movimiento realmente vinculado.
  const isBankMovement = movementTable === 6 || movementTable === 7
  const isSiiOrigin =
    !isBankMovement && String(item.origen ?? '').trim().toLowerCase() === 'sii'
  const clientName = !isBankMovement && !isSiiOrigin
    ? item.name || item.descripcion || displayName
    : item.descripcion || displayName

  return {
    ...item,
    ...(item.montoTotal == null && Number.isFinite(amount) ? { montoTotal: amount } : {}),
    ...(item.montoCargo == null && tipoMovimiento === 'cargo' && Number.isFinite(amount)
      ? { montoCargo: amount }
      : {}),
    ...(item.montoAbono == null && tipoMovimiento === 'abono' && Number.isFinite(amount)
      ? { montoAbono: amount }
      : {}),
    ...(tipoMovimiento ? { tipoMovimiento } : {}),
    ...(isSiiOrigin && item.nombreFolio == null && displayName
      ? { nombreFolio: displayName }
      : {}),
    ...(!isSiiOrigin && item.nombreBanco == null && displayName
      ? { nombreBanco: displayName }
      : {}),
    ...(!isSiiOrigin && item.nombreCuentaBanco == null && displayName
      ? { nombreCuentaBanco: displayName }
      : {}),
    ...(item.razonSocial == null && clientName
      ? { razonSocial: clientName }
      : {}),
    ...(item.descripcion == null && item.razonSocial ? { descripcion: item.razonSocial } : {}),
    ...(isSiiOrigin && item.numeroFolio == null && displayNumber != null
      ? { numeroFolio: displayNumber }
      : {}),
    ...(!isSiiOrigin && item.numeroBanco == null && displayNumber != null
      ? { numeroBanco: displayNumber }
      : {}),
    ...(!isSiiOrigin && item.numeroCuentaBanco == null && displayNumber != null
      ? { numeroCuentaBanco: displayNumber }
      : {})
  }
}

export const normalizeConciliationPayload = payload => {
  if (!payload || typeof payload !== 'object') return payload ?? {}

  const normalizeRows = rows =>
    Array.isArray(rows) ? preferAdjustmentConciliationRows(rows.map(normalizeConciliationLinkageItem)) : rows

  return {
    ...payload,
    linkage: normalizeRows(payload.linkage),
    linkagePrevired: normalizeRows(payload.linkagePrevired)
  }
}
